import { createAction } from '@reduxjs/toolkit';

import { ActionClearType, REDIRECT_TO } from 'constants/redux-actions';

const clearRedirectPath = createAction(ActionClearType(REDIRECT_TO));
const redirectTo = (path) => createAction(REDIRECT_TO)(path);

const storeRedirectActions = { clearRedirectPath, redirectTo };

export default storeRedirectActions;
